// Turn optional "# Section" labels in Ghost's secondary navigation into
// accessible footer columns. Without markers, the navigation remains one list.
(function () {
    var navigation = document.querySelector('.site-footer-nav');
    var list = navigation && navigation.querySelector('ul');

    if (!list) {
        return;
    }

    var items = Array.from(list.children);
    var hasMarkers = items.some(function (item) {
        return item.textContent.trim().startsWith('#');
    });

    if (!hasMarkers) {
        return;
    }

    var columns = document.createElement('div');
    columns.className = 'site-footer-nav-columns';
    var currentList;

    items.forEach(function (item) {
        var label = item.textContent.trim();

        if (label.startsWith('#')) {
            var column = document.createElement('section');
            var heading = document.createElement('p');

            column.className = 'site-footer-nav-column';
            heading.className = 'site-footer-label';
            heading.textContent = label.replace(/^#\s*/, '');
            currentList = document.createElement('ul');
            column.appendChild(heading);
            column.appendChild(currentList);
            columns.appendChild(column);
            return;
        }

        if (!currentList) {
            var fallbackColumn = document.createElement('section');
            currentList = document.createElement('ul');
            fallbackColumn.className = 'site-footer-nav-column';
            fallbackColumn.appendChild(currentList);
            columns.appendChild(fallbackColumn);
        }

        currentList.appendChild(item);
    });

    list.replaceWith(columns);
})();
